<template>
  <div class="steps-line-cp-container">
    <div class="steps-item" v-for="(i,index) in data" :key="index">
      <div class="title" :class="[
                      index === activeIndex?'title-active':'',
                      index < activeIndex?'title':'',
                      index > activeIndex?'title-out':'',
                    ]">{{i.name}}</div>
      <span class="icon-ok" v-if="index < activeIndex"></span>
      <div class="icon-choose-box" v-if="index === activeIndex">
        <img class="icon-choose" src="../common/images/steps-it.png">
      </div>
      <span class="icon-empty" v-if="index > activeIndex"></span>
      <div v-if="index!==activeIndex" class="cross-line" :class="index > activeIndex?'cross-line-gray':''"></div>
      <div v-if="index===activeIndex">
        <div class="cross-line-left"></div>
        <div class="cross-line-right"></div>
      </div>
      <div class="time" v-if="index==3">
        <div class="end-text">答题截止</div>
        <div class="end-date">{{step.dyEnddate}}</div>
      </div>
      <div class="time" v-if="index==4">
        <div class="end-text">回标截止</div>
        <div class="end-date">{{step.hbEnddate}}</div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: "steps-line-cp",
  props: {
    data: {
      type: Array,
      default: () => [
        {
          name: '报名',
          time: '2017/10/1 12:00',
        },
        {
          name: '入围',
          time: '2017/10/1 12:00',
        },
        {
          name: '发标',
          time: '',
        },
        {
          name: '回标',
          time: '',
        },
        {
          name: '中标',
          time: '',
        }
      ]
    },
    activeIndex: {
      type: Number,
      default: () => 0
    },
    step: {
      type: Object,
      default: () => { }
    }
  },
  data() {
    return {}
  },
  mounted() {

  },
  created() {
    console.log('this---step', this.step)
  },
  components: {

  },

  methods: {}

}
</script>

<style scoped lang="scss">
.steps-line-cp-container {
  display: flex;
  width: 100%;
  align-items: center;
  text-align: center;
  .steps-item {
    width: 100%;
    height: 130px;
    position: relative;
    .title {
      font-size: 26px;
      color: #333333;
      position: relative;
      bottom: -20px;
    }
    .title-active {
      color: #1ed1d9;
    }
    .title-out {
      color: #999999;
    }
    .icon-empty {
      display: block;
      height: 20px;
      width: 20px;
      background: white;
      border: 1px solid #1ab3e2;
      border-radius: 50%;
      background-size: 100% 100%;
      box-shadow: 0px 0px 12px 1px #1ab3e2;
      position: absolute;
      left: calc(50% - 10px);
      top: calc(50% - 10px);
      z-index: 99;
    }
    .icon-ok {
      display: block;
      background: url("../common/images/stpes-ok.png") no-repeat center;
      height: 30px;
      width: 30px;
      background-size: 100% 100%;
      border-radius: 50%;
      position: absolute;
      left: calc(50% - 15px);
      top: calc(50% - 15px);
      z-index: 99;
    }
    .icon-choose-box {
      left: calc(50% - 15px);
      top: calc(50% - 15px);
      height: 30px;
      color: white;
      width: 30px;
      position: absolute;
      box-shadow: 0px 0px 12px 1px #1ed1d9;
      background: #1ed1d9;
      border-radius: 50%;
      z-index: 99;
    }
    .icon-choose {
      height: 20px;
      width: 20px;
      -webkit-animation: animal 1s infinite linear;
      position: absolute;
      left: calc(50% - 10px);
      top: calc(50% - 10px);
      z-index: 99;
    }
    @-webkit-keyframes animal {
      0% {
        transform: rotate(0deg);
        -ms-transform: rotate(0deg);
        -webkit-transform: rotate(0deg);
      }
      100% {
        transform: rotate(360deg);
        -ms-transform: rotate(360deg);
        -webkit-transform: rotate(360deg);
      }
    }
    .time {
      font-size: 22px;
      position: relative;
      top: 55px;
    }
    .time-active {
      width: 60px;
      height: 32px;
      color: white;
      background: #2dd4dc;
      padding-top: 3px;
      font-size: 20px;
      text-align: center;
      border-radius: 15px;
      left: calc(50% - 30px);
    }
    .cross-line {
      height: 2px;
      width: 100%;
      background: #4ecb9d;
      position: absolute;
      top: calc(50% - 1px);
      left: 0;
    }
    .cross-line-left {
      height: 2px;
      width: 50%;
      background: #4ecb9d;
      position: absolute;
      top: calc(50% - 1px);
      left: 0;
    }
    .cross-line-right {
      height: 2px;
      width: 50%;
      background: #cdcfd4;
      position: absolute;
      top: calc(50% - 1px);
      right: 0;
    }
    .cross-line-gray {
      background: #cdcfd4;
    }
    .end-text{
      color: #333;
    }
    .end-date {
      color: #333;
      font-size: 22px;
      margin-top: 4px;
    }
  }
}
</style>
<style lang="scss">
.steps-line-cp-container {
}
</style>